import { render, staticRenderFns } from "./AuthSplash.vue?vue&type=template&id=765f3f54&"
import script from "./AuthSplash.vue?vue&type=script&lang=ts&"
export * from "./AuthSplash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports